export default __webpack_public_path__ + "static/media/Mion.563b3ed9.ico";